angular.module('zc.master.zcliteKpi', [
  'zc.master'
])



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_kpi/index.coffee